import { ClipboardCheck } from "lucide-react";
import {
  ProblemStatementParamsSchema,
  defaultProblemStatementParams,
  type ProblemStatementParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ProblemStatementWidget } from "./Component.js";
import { ProblemStatementExpandedEditor } from "./ExpandedEditor.js";

/**
 * Problem Statement — Specify, singleton. Tinted-cyan body block with
 * "PROBLEM" eyebrow + one paragraph. The Solve title acts as the
 * headline so the schema is a single text field.
 */
export const problemStatementDef: WidgetDef<ProblemStatementParams> = {
  kind: "problemStatement",
  label: "Problem Statement",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 352, h: 324 },
  defaultParams: defaultProblemStatementParams,
  Component: ProblemStatementWidget,
  ExpandedComponent: ProblemStatementExpandedEditor,
  expandable: true,
  storage: "sql",
  schema: ProblemStatementParamsSchema,
  accent: "cyan",
  icon: ClipboardCheck,
  subtitle: "Frame the problem clearly",
  defaultRoster: true,
  category: "single",
  layout: { col: 0, row: 0, width: 352, height: 300 },
  renderFooter: (data, { hostMetadata }) => ({
    left: hostMetadata?.ownerName
      ? `Owner · ${hostMetadata.ownerName}`
      : "Owner",
    right:
      data.problem.trim() && hostMetadata?.updatedAtLabel
        ? `Last updated ${hostMetadata.updatedAtLabel}`
        : "Draft",
  }),
};

registerWidget(problemStatementDef);
